
export const environment = {
  production: false,
    firebase : {
    apiKey: "AIzaSyA4RkolECH0I8J6MzHIV5kIwmZsWtvAgIw",
    authDomain: "foldingathome-b96a4.firebaseapp.com",
    databaseURL: "https://foldingathome-b96a4.firebaseio.com",
    projectId: "foldingathome-b96a4",
    storageBucket: "foldingathome-b96a4.appspot.com",
    messagingSenderId: "698586401556",
    appId: "1:698586401556:web:039e488e3cf102e0e61001",
    measurementId: "G-63VZSKDLZT"
  }
};